// Determine environment using process.env
// Defaults to production when NODE_ENV is 'production'; otherwise development.
const isProd = process.env.NODE_ENV === 'production';

// Optionally override base URL via REACT_APP_API_BASE_URL
const getBaseUrl = () => {
  const envUrl = process.env.REACT_APP_API_BASE_URL;
  if (envUrl) {
    return envUrl;
  }
  return isProd
    ? '/api'
    : 'http://localhost:5001/api';
};

export const API_BASE_URL = getBaseUrl();

